/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBatchExecutions = /* GraphQL */ `
  query GetBatchExecutions($jobDefinitions: [String]) {
    getBatchExecutions(jobDefinitions: $jobDefinitions) {
      jobId
      jobName
      jobArn
      status
      statusReason
      createdAt
      startedAt
      stoppedAt
      __typename
    }
  }
`;
export const getJobQueues = /* GraphQL */ `
  query GetJobQueues {
    getJobQueues {
      jobQueueName
      __typename
    }
  }
`;
export const getJobDefinitions = /* GraphQL */ `
  query GetJobDefinitions($status: String) {
    getJobDefinitions(status: $status) {
      jobDefinitionName
      jobDefinitionArn
      revision
      type
      status
      __typename
    }
  }
`;
export const getScheduledRules = /* GraphQL */ `
  query GetScheduledRules {
    getScheduledRules {
      Name
      Arn
      EventPattern
      State
      Description
      ScheduleExpression
      ManagedBy
      EventBusName
      __typename
    }
  }
`;
export const getExecutionReport = /* GraphQL */ `
  query GetExecutionReport($reportName: String!) {
    getExecutionReport(reportName: $reportName)
  }
`;
export const hasExecutionReport = /* GraphQL */ `
  query HasExecutionReport($reportName: String!) {
    hasExecutionReport(reportName: $reportName)
  }
`;
export const getLogEvents = /* GraphQL */ `
  query GetLogEvents($jobId: String!) {
    getLogEvents(jobId: $jobId) {
      nextForwardToken
      events {
        timestamp
        message
        __typename
      }
      __typename
    }
  }
`;
export const getJobDescription = /* GraphQL */ `
  query GetJobDescription($jobId: String) {
    getJobDescription(jobId: $jobId) {
      jobId
      status
      __typename
    }
  }
`;
